import { LENGTH_VALUES } from '../../../../constants/validations';
import amountValidator from '../../../../utils/validations/amountValidator';

export const amountFieldProps = formatMessage => ({
  className: 'mt1',
  type: 'text',
  inputMode: 'decimal',
  limit: LENGTH_VALUES.COPAY.MAX,
  placeholder: formatMessage({
    id: 'virtualVisit.details.paymentAmount',
  }),
  errorText: formatMessage({ id: 'errors.appointment.copay' }),
  validationRule: amountValidator,
});



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/PaymentAmountField/field.js